---
title: Boxes
description: Boxes help you group cards, add structure, and guide collaborators around your spaces
category: Basics
updated: 2026-09-03
video: https://updates.kinopio.club/pages/help/posts/boxes/demo.mp4
---

# Boxes

Boxes help you group, add structure, and guide collaborators around cards,

Helpful for adding sections, groups, lists, venn diagrams, or even swimlanes to your spaces

<video autoplay loop muted playsinline class="medium">
  <source src="https://updates.kinopio.club/pages/help/posts/boxes/demo.mp4">
</video>


Snap: If you drag a box near the *outer* edge of another box you'll snap them together. Handy for making grids, tables, and calendars.

<video autoplay loop muted playsinline class="medium">
  <source src="https://updates.kinopio.club/pages/help/posts/boxes/outer-snap.mp4">
</video>


Expand: Boxes can also grow to envelop cards when you drag them over an *inner* edge. Boxes snap together the same way. Handy for making room inside crowded boxes.

<video autoplay loop muted playsinline class="medium">
  <source src="https://updates.kinopio.club/pages/help/posts/boxes/inner-snap.mp4">
</video>


## Pro-Tips

- ⌘/ctrl-click a box to select the cards inside it
- alt-drag to move a box without moving cards
- drag the bottom-right box corner to resize
- click box label to change their color and give them a background image
- filter by box to focus only on what's in the box, everything outside will be faded out
- You can add background images to boxes as well
